<h2 mat-dialog-title>{{title}}</h2>

<div mat-dialog-content>

    <div fxLayout="row stretch" fxLayout.xs="column">
        <mat-label>{{message}}</mat-label>
    </div>
    <form [formGroup]="formGroup">
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Fecha Ingreso</mat-label>
              <input matInput [matDatepicker]="fechaIngresoPicker" formControlName="FechaIngreso"
                (click)="fechaIngresoPicker.open()">
              <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaIngresoPicker">
              </mat-datepicker-toggle>
              <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaIngreso')">
                <mat-icon matDatepickerToggleIcon>clear</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #fechaIngresoPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Fecha Egreso</mat-label>
              <input matInput [matDatepicker]="fechaEgresoPicker" formControlName="FechaEgreso"
                (click)="fechaEgresoPicker.open()">
              <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaEgresoPicker">
              </mat-datepicker-toggle>
              <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaEgreso')">
                <mat-icon matDatepickerToggleIcon>clear</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #fechaEgresoPicker></mat-datepicker>
            </mat-form-field>
          </div>
    </form>

</div>

<br/>

<div mat-dialog-actions>
    <div fxLayout="row stretch" fxLayout.xs="column">
        <button mat-raised-button color="primary" (click)="onAccept()" class="zb-button">{{buttonAcceptText}}</button>
        <button mat-raised-button color="warn" (click)="onDecline()" class="zb-button">{{buttonCancelText}}</button>
    </div>
</div>
